module.exports = __webpack_public_path__ + "static/media/view2.01d6ce86.jpg";